<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <div class="card-header">
        回贴榜
      </div>
      <div class="card-content">
        <div class="card-content-item" :key="index" v-for="(item, index) in datas">
            <img v-lazy="item.avatar" alt="">
            <span class="name">{{item.nickName}}</span>
            <span class="count">{{item.replyCount}}次回答</span>
        </div>
      </div>
    </div>
    <Loading :loading="false"/>
  </div>
</template>

<script>
import Loading from './Loading.vue'
import { get } from '../utils/request'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('refresh')
export default {
  components: {
    Loading
  },
  props: [
    'selfStyle'
  ],
  data () {
    return {
      datas: [],
      loading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      const promise = get({
        url: '/user/returnList'
      })
      promise.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          this.datas = detail
        }
        this.loading = false
      })
    }
  },
  computed: {
    ...mapGetters({
      getDownRefresh: 'getDownRefresh'
    })
  },
  watch: {
    getDownRefresh (value) {
      if (!value) {
        this.getList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  box-sizing: border-box;
  padding: 0 7.5px;
  width: 100%;
  border-radius: 2px;
  margin-bottom: 15px;
  background: transparent;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
    .card-content {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .card-content-item {
        position: relative;
        height: 85px;
        font-size: 12px;
        display: inline-block;
        margin: 10px 10px 5px 10px;
        box-sizing: border-box;
        img {
          width: 65px;
          height: 65px;
          background:#666;
        }
        .name {
          position: absolute;
          bottom: 20px;
          width: 65px;
          left: 0;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background-color: rgba(0,0,0,.2);
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .count {
          position: absolute;
          width: 65px;
          bottom: 0;
          left: 0;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-style: normal;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
